// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cc070c5b","453":"0f776a1e","455":"7fe5cd29"}[chunkId] + ".chunk.js";
};